export enum HttpAction {
    'get' = 'get',
    'post' = 'post',
    'patch' = 'patch',
    'delete' = 'delete'
}
